<template>
  <!-- 我要报价弹窗 -->
  <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
             title="我要报价" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
    <div class="dialog-content">

      <el-form :model="quoteForm" label-width="120px" :rules="quoteFormRules" ref="quoteForm">
        <el-form-item label="期望价格">
          <div class="price-row">
            <span>{{ row.expected_price || '' }}元</span>
            <div class="contact-right">
              <template v-if="userInfo.vip_status != 1">
                <el-button type="primary" size="small" @click="goVip">查看需求方联系方式</el-button>
              </template>
              <template v-else-if="userInfo.member_type == 1">
                <el-button type="primary" size="small" @click="goVip">升级SVIP</el-button>
              </template>
              <template v-else>
                <span class="contact-phone">联系方式：{{ row.people && row.people.mobile ? row.people.mobile : '--' }}</span>
              </template>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="是否现货" prop="is_quote">
          <el-radio-group v-model="quoteForm.is_quote">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="quoteForm.is_quote == 0" label="备货天数" prop="stock_day">
          <el-input v-model="quoteForm.stock_day" placeholder="请输入" type="number">
            <template slot="append"> 天</template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="数量">
          <el-input v-model="quoteForm.number" placeholder="请输入" type="number">
            <el-select  v-model="quoteForm.unit" slot="append" class="unit-select" placeholder="请选择单位">
              <el-option v-for="i in unitList" :key="i.id" :label="i.label" :value="i.label"></el-option>
            </el-select>
          </el-input>
        </el-form-item> -->


        <el-form-item label="数量" prop="number">
          <el-input v-model="quoteForm.number" placeholder="请输入" type="number">
            <template slot="append">
              {{ quoteForm.unit }}
              <!-- <el-select prop="unit" style="width: 100px" v-model="quoteForm.unit" placeholder="请选择">
                <el-option v-for="i in unitList" :key="i.id" :label="i.label" :value="i.label"></el-option>
              </el-select> -->
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="单价(含税运)" prop="unit_price">
          <el-input v-model="quoteForm.unit_price" placeholder="请输入">
            <template slot="append"> 元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="总价" prop="total_price">
          <div class="all-price">
            <div>
              {{ quoteForm.total_price }}
            </div>
            <div class="unit-style">元</div>
          </div>
        </el-form-item>
        <el-form-item label="纯度" prop="purity">
          <el-input v-model="quoteForm.purity" placeholder="请输入">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
        <el-form-item label="备货天数" prop="stock_day">
          <el-input v-model="quoteForm.stock_day" placeholder="请输入">
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoice_type">
          <el-radio-group v-model="quoteForm.invoice_type">
            <el-radio :label="1">专票(13%)</el-radio>
            <el-radio :label="2">普票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="quoteForm.remark" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer flex-end">
      <gradient-button color="#5F616C" border="1px solid #5F616C" background="transparent" @hit="handleClose">取消
      </gradient-button>
      <gradient-button background="#0C60E6" @hit="handleSubmit">提交</gradient-button>
    </div>
  </el-dialog>
</template>
<script>
import gradientButton from "../button/gradient-button.vue";
import {mapGetters} from "vuex";
import {
  quote_product,
} from "@/api/modules/user";

export default {
  components: {
    gradientButton
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      // 报价表单
      quoteForm: {
        is_quote: 1,
        number: "",
        unit: "",
        unit_price: "",
        total_price: "",
        purity: "",
        stock_day: "",
        invoice_type: 1,
        remark: "",
      },
      // 报价表单验证
      quoteFormRules: {
        is_quote: [
          {required: true, message: "请选择是否现货", trigger: "change"},
        ],
        stock_day: [
          {required: true, message: "请输入备货天数", trigger: "blur"},
        ],
        unit: [{required: true, message: "请选择单位", trigger: "change"}],
        number: [
          {required: true, message: "请输入数量", trigger: "blur"},
          {
            validator: this.validateNumber,
            trigger: "blur",
          },
          {
            validator: this.validateNumberNext,
            trigger: "blur",
          }
        ],
        unit_price: [
          {required: true, message: "请输入单价", trigger: "blur"},
          {
            validator: this.validateNumber,
            trigger: "blur",
          },
        ],

        total_price: [
          {required: true, message: "请输入含运费总价", trigger: "blur"},
          {
            validator: this.validateNumber,
            trigger: "blur",
          },
        ],

        purity: [{required: true, message: "请输入纯度", trigger: "blur"}],
        invoice_type: [
          {required: true, message: "请选择发票类型", trigger: "change"},
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    unitList() {
      return this.$store.state.config.unitList
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal) {
        this.resetForm()
      }
    },
    'quoteForm.number': function (val) {
      // 约束：数量不能小于0，且不能大于 row.number
      const max = parseFloat(this.row.number)
      let n = parseFloat(val)
      if (!isFinite(n)) {
        this.quoteForm.number = ''
        this.recalcTotalPrice()
        return
      }
      if (n < 0) n = 0
      if (isFinite(max) && n > max) {
        n = max
        // 仅在确实超出时提示一次
        this.$message && this.$message.warning && this.$message.warning('数量不能大于可报价数量')
      }
      if (n !== parseFloat(this.quoteForm.number)) {
        this.quoteForm.number = n
      }
      this.recalcTotalPrice()
    },
    'quoteForm.unit_price': function () {
      this.recalcTotalPrice()
    }
  },
  methods: {
    resetForm() {
      // 若有表单引用，先重置校验状态
      if (this.$refs.quoteForm && this.$refs.quoteForm.resetFields) {
        this.$refs.quoteForm.resetFields()
      }
      // 明确重置各字段
      this.quoteForm.is_quote = 1

      this.quoteForm.unit_price = ""
      this.quoteForm.total_price = ""
      this.quoteForm.purity = ""
      this.quoteForm.stock_day = ""
      this.quoteForm.invoice_type = 1
      this.quoteForm.remark = ""
      this.quoteForm.number = this.row.number
      this.quoteForm.unit = this.row.unit
      this.$nextTick(() => {
        this.$refs.quoteForm && this.$refs.quoteForm.clearValidate && this.$refs.quoteForm.clearValidate()
      })
    },
    // 数字校验 + 上限校验（用于el-form rules）
    validateNumber(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        return callback(new Error('请输入数字'))
      }
      const num = parseFloat(value)
      if (!isFinite(num) || num < 0) {
        return callback(new Error('请输入有效的非负数字'))
      }

      callback()
    },
    validateNumberNext(rule, value, callback) {
      const num = parseFloat(value)
      const max = parseFloat(this.row.number)
      if (isFinite(max) && num > max) {
        return callback(new Error(`数量不能大于${max}`))
      }
      callback()
    },
    recalcTotalPrice() {
      const n = parseFloat(this.quoteForm.number)
      const p = parseFloat(this.quoteForm.unit_price)
      if (isFinite(n) && isFinite(p)) {
        const total = n * p
        // 保留两位小数显示
        this.quoteForm.total_price = (Math.round(total * 100) / 100).toFixed(2)
      } else {
        this.quoteForm.total_price = ""
      }
    },
    handleSubmit() {
      this.$refs.quoteForm.validate((valid) => {
        if (valid) {
          quote_product(this.row.id, this.quoteForm).then((res) => {
            if (res.data.code == 10000) {
              this.$message.success({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
              this.$emit('refresh')
              this.$emit('changeDialog', false)
              this.$refs.quoteForm.resetFields();
              this.quoteForm.unit = this.unitList[0].label;
              this.quoteForm.is_quote = 1;
            } else {
              this.$message.error({
                message: res.data.message,
                duration: 2000,
                offset: 200,
              });
            }
          });
        }
      });
    },
    handleClose() {
      this.$emit('changeDialog', false)
    },
    goVip() {
      const routeData = this.$router.resolve({path: '/vip/vip'})
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  line-height: 40px;

  .contact-phone {
    font-size: 14px;
    color: #00112b;
  }
}

.all-price {
  display: flex;
  justify-content: space-between;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 0 0 15px;
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
  cursor: not-allowed !important;
  background: #F5F7FA;

  .unit-style {
    background-color: #F5F7FA;
    color: #909399;
    position: relative;
    border-left: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 0 20px 0 20px;
  }
}
</style>
